// Types

export type State = {
  withSearchHero: boolean;
};

type SetWithSearchHeroAction = {
  type: 'SET_WITH_SEARCH_HERO';
  payload: {
    withSearchHero: boolean;
  };
};

type SetHideSalarySurveyAdType = {
  type: 'SET_HIDE_SALARY_SURVEY_AD';
  payload: {
    hideSalarySurveyAd: boolean;
  };
};

type SetHadResumeDatabaseAdType = {
  type: 'SET_HAD_RESUME_DATABASE_AD';
  payload: {
    hadResumeDatabaseAd: boolean;
  };
};

export type Action =
  | SetWithSearchHeroAction
  | SetHideSalarySurveyAdType
  | SetHadResumeDatabaseAdType;

// Reducer

const initialState = {
  hadResumeDatabaseAd: false,
  hideSalarySurveyAd: false,
  withSearchHero: true,
};

export default function layoutReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = initialState,
  action: Action
) {
  switch (action.type) {
    case 'SET_WITH_SEARCH_HERO':
      return { ...state, withSearchHero: action.payload.withSearchHero };

    case 'SET_HIDE_SALARY_SURVEY_AD':
      return {
        ...state,
        hideSalarySurveyAd: action.payload.hideSalarySurveyAd,
      };

    case 'SET_HAD_RESUME_DATABASE_AD':
      return {
        ...state,
        hadResumeDatabaseAd: action.payload.hadResumeDatabaseAd,
      };

    default:
      return state;
  }
}

// Actions

export const setWithSearchHero = (
  withSearchHero: boolean
): SetWithSearchHeroAction => ({
  type: 'SET_WITH_SEARCH_HERO',
  payload: {
    withSearchHero,
  },
});

export const setHadResumeDatabaseAd = (
  hadResumeDatabaseAd: boolean
): SetHadResumeDatabaseAdType => ({
  type: 'SET_HAD_RESUME_DATABASE_AD',
  payload: {
    hadResumeDatabaseAd,
  },
});

export const setHideSalarySurveyAd = (
  hideSalarySurveyAd: boolean
): SetHideSalarySurveyAdType => ({
  type: 'SET_HIDE_SALARY_SURVEY_AD',
  payload: {
    hideSalarySurveyAd,
  },
});
